import styled from "styled-components";

export const Title = styled.h3`
  color: #353535;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.4;
  margin: 0 0 16px;
  padding-left: 5px;

  @media screen and (max-width: 820px) {
    font-size: 1.05rem;
    margin-bottom: 12px;
  }
`;
